import { Injectable, signal } from '@angular/core';
import { MasterdataCustomer } from '@softapps/core/masterdata';

@Injectable()
export class SalesOverviewStateService {
  readonly selectedCustomer = signal<MasterdataCustomer | null>(null);
  readonly pendingRecentRefresh = signal(false);
}
